import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 section-padding">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-xs font-medium text-accent-600 uppercase tracking-wider font-label">Browse</p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-2">
              Shop by <span className="italic text-accent-500">Category</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-md">
              Explore Mulebuy Spreadsheet-powered category collections — curated links to specialized products on the main platform.
            </p>
          </div>
          <span className="inline-flex items-center px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold font-label whitespace-nowrap">
            {categories.length} CATEGORIES
          </span>
        </div>

        <div
          className="flex overflow-x-auto gap-4 pb-4 -mx-4 px-4 md:px-0 snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {categories.map((cat) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[240px] md:w-[280px] snap-start group cursor-pointer"
            >
              <div className="rounded-2xl overflow-hidden bg-background-50 hover:bg-background-100 transition-all duration-300 h-full flex flex-col">
                <div className="relative w-full aspect-[4/3] overflow-hidden">
                  <img
                    src={cat.imageUrl}
                    alt={`${cat.name} — Mulebuy Spreadsheet category`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>
                  <span className="absolute bottom-3 left-3 text-xs font-semibold text-white font-label bg-black/40 px-2.5 py-1 rounded-full">
                    {cat.name}
                  </span>
                </div>
                <div className="p-4 flex-1 flex flex-col justify-between">
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{cat.description}</p>
                  <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-accent-600 font-label group-hover:gap-2 transition-all">
                    Browse {cat.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}